import { Box, Divider, FormControlLabel, Grid, Paper, Switch, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TextLabel from '../Components/Common/CommonTextLabel'
import ButtonContained from '../Components/Common/ButtonContained'
import ButtonOutlined from '../Components/Common/ButtonOutlined'
import { makeStyles } from 'tss-react/mui'
import PaperCommon from '../Components/Common/PaperCommon'
import SearchIcon from '@mui/icons-material/Search';
import { checkAccess, SidebarIcon } from '../Utils/handler'
import BarChartComponent from '../Components/PagesComponents/BarChartComponet'
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CallMadeIcon from '@mui/icons-material/CallMade';
// import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { useTheme } from '@emotion/react'
import Assets from '../Components/Common/Assets'
import { useLocation, useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { showLoader } from '../Redux/Slices/loaderSlice'
import { getAvailableAccess } from '../Redux/Actions/action'

const useStyles = makeStyles()((theme) => {
    return {
        main_labla: {
            // display: "flex",
            borderRadius: "20px",
            padding: "20px 20px",
            backgroundColor: "#3E4094",
            alignItems: "flex-start",
            // justifyContent: "space-between",
            // flexDirection: "column",
            // gap: "10px",
            [theme.breakpoints.up('sm')]: {
                //     flexDirection: "row",
                alignItems: "center",
                padding: "25px 30px",
            },
        },
        main_button: {
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            marginTop: "10px",
            [theme.breakpoints.up('sm')]: {
                marginTop: "0px",
                justifyContent: "flex-end",
            },

        },
        toggleButtonGroup: {
            backgroundColor: '#f5f5fa',
            borderRadius: '10px',
            padding: '3px',
            display: 'flex',
            width: '100%',
            '& .MuiToggleButton-root': {
                textTransform: 'none',
                color: '#999',
                borderColor: 'transparent',
                flex: 1,
                padding: '2px 10px',
                transition: 'all 0.3s ease-in-out',
                '&.Mui-selected': {
                    backgroundColor: '#ffffff',
                    color: '#000',
                    borderRadius: '8px',
                },
            },
            '& .MuiToggleButtonGroup-root': {
                boxShadow: 'none',
            },
        },
        rupeesBox: {
            width: 40,
            height: 40,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }
    }
})

const data = [
    { name: "18 Oct", newInsurance: 4000, claims: -9398 },
    { name: "25 Oct", newInsurance: 3000, claims: -1398 },
    { name: "2 Nov", newInsurance: 900, claims: -3800 },
    { name: "9 Nov", newInsurance: -2780, claims: 3908 },
    { name: "18 Oct", newInsurance: 890, claims: -4800 },
    { name: "25 Oct", newInsurance: -2390, claims: 3800 },
    { name: "2 Nov", newInsurance: 3490, claims: -9300 },
];

const Dashboard = () => {
    // ---------- Hook -----------
    const { classes } = useStyles();
    const theme = useTheme()
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const dispatch = useDispatch();
    const dataAccess = useSelector(value => value?.allAvailableAccess?.AllAvailableAccessList)

    // --------------- State -------------
    const [view, setView] = useState('weekly');

    // --------------- handleChange --------------- 
    const handleChange = (e, newView) => {
        if (newView !== null) {
            setView(newView);
        }
    }

    // ---------- useEffect ------------ 
    useEffect(() => {
        dispatch(showLoader(true));
        dispatch(getAvailableAccess())
            .unwrap() // Automatically handles async response
            .catch((error) => console.error("error", error))
            .finally(() => dispatch(showLoader(false)));
    }, [dispatch]);

    return (
        <>
            <Grid container gap={2}>
                <Grid container item xs={12} className={classes.main_labla} >
                    <Grid item xs={12} sm={6} alignItems={"flex-start"} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: { xs: "5px", sm: "20px" } }} >
                        {checkAccess(pathname, dataAccess, 'Total Balance') && <TextLabel
                            title={"Total Balance"} fontSize={{ xs: "18px", sm: "22px" }} lineHeight={"29.11px"} color='#FFFFFF'
                        />}
                        <TextLabel
                            title={`₹${"3,20,45,000"}`} fontSize={{ xs: "30px", sm: "50px" }} lineHeight={"49.33px"} fontWeight={700} color='#FFFFFF'
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} className={classes.main_button}>

                        <ButtonContained
                            text={"Add Member"}
                            color={"#3E4094"}
                            fontWeight={600}
                            backgroundColor={"#FFFFFF"}
                            lineHeight={"24.5px"}
                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                            fontSize={{ xs: "13px", md: "14px" }}
                            height={{ xs: "40px", sm: "40px" }}
                            onClick={() => navigate('/addMember')}
                        />

                        <ButtonContained
                            text={"Verify Documents"}
                            color={"#3E4094"}
                            fontWeight={600}
                            backgroundColor={"#FFFFFF"}
                            lineHeight={"24.5px"}
                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "40px", sm: "40px" }}
                        />

                        <ButtonOutlined
                            text={"Claim Management"}
                            color={"#FFFFFF"}
                            fontWeight={600}
                            lineHeight={"24.5px"}
                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "40px", sm: "40px" }}
                        />

                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <PaperCommon
                        borderRadius={'20px'}
                        padding={'10px'}
                        contant={
                            <>
                                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} flexWrap={'wrap'} >
                                    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={0.8}>
                                        <SearchIcon sx={{ color: "#3E4094", fontSize: "1rem" }} />
                                        <TextLabel title={"Claim Management"} fontSize={{ xs: "12px", sm: "16px" }} lineHeight={"29.11px"} color={"#3E4094"} fontWeight={600} />
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                                        <ToggleButtonGroup
                                            value={view}
                                            exclusive
                                            onChange={handleChange}
                                            className={classes.toggleButtonGroup}
                                        >
                                            <ToggleButton value="weekly">Weekly</ToggleButton>
                                            <ToggleButton value="daily">Daily</ToggleButton>
                                        </ToggleButtonGroup>
                                        <ButtonContained startIcon={<Assets height={'15px'} width={'15px'} src={'images/settingss.svg'} />} text={"Manage"} color={'black'} backgroundColor={"#FFFFFF"} padding={{ xs: "10px 30px", md: "15px 35px" }} fontSize={{ xs: "12px", md: "14px" }} sx={{ border: '1px solid #f5f5fa', }} />
                                    </Box>
                                </Box>
                                <Box display="flex" gap={4} p={2} alignItems="center">
                                    <Grid container spacing={1} xs={12} >
                                        <Grid item xs={12} md={8} lg={8} >
                                            {/* Chart Section */}
                                            <Box width="100%">
                                                <Typography variant="subtitle1" align="left">
                                                    New Insurance
                                                </Typography>
                                                <BarChartComponent
                                                    data={data}
                                                    bars={[
                                                        { dataKey: "newInsurance", color: "#F87C2B", radius: [10, 10, 0, 0] },
                                                        { dataKey: "claims", color: "#4B3ECA", radius: [10, 10, 0, 0] },
                                                    ]}
                                                />
                                                <Typography variant="subtitle1" align="left">
                                                    Claims
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={4} mt={{ md: 8 }} >
                                            <Box display="flex" flexDirection="column" >
                                                <Box display={'flex'} alignItems={'center'} paddingBottom={3} gap={2}>
                                                    <Box className={classes?.rupeesBox} backgroundColor={'#F87C2B'}>
                                                        <CallReceivedIcon sx={{ color: "#FFF" }} />
                                                    </Box>
                                                    <Box>
                                                        <Typography variant="body2" color="textSecondary">
                                                            Income
                                                        </Typography>
                                                        <Typography variant="h6" sx={{ color: "#F87C2B", fontWeight: 600 }}>
                                                            ₹ 12,43,231{" "}
                                                            <span style={{ fontSize: "0.8rem", color: "gray", fontWeight: 500 }}>45.0%</span>
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Divider />
                                                <Box>
                                                    <Box display={'flex'} alignItems={'center'} paddingTop={3} gap={2}>
                                                        <Box className={classes?.rupeesBox} backgroundColor={'#4B3ECA'}>
                                                            <CallMadeIcon sx={{ color: "#FFF" }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="body2" color="textSecondary">
                                                                General Expense
                                                            </Typography>
                                                            <Typography variant="h6" sx={{ color: "#4B3ECA", fontWeight: 600 }}>
                                                                ₹ 8,50,000{" "}
                                                                <span style={{ fontSize: "0.8rem", color: "gray", fontWeight: 500 }}>55.0%</span>
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </Box>
                            </>
                        }
                    />
                </Grid>
                <Grid container item spacing={2} xs={12}>
                    <Grid item xs={12} sm={6} md={4}>
                        <PaperCommon
                            borderRadius={'16px'}
                            padding={'15px'}
                            contant={<SummaryTotal title={"Total Member Count"} dayTitle={'Last 30 days'} count={'12,987'} countLabel={'Active Member'} memberDetail={'30% New Members in 6 Month'} />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <PaperCommon
                            borderRadius={'16px'}
                            padding={'15px'}
                            contant={<SummaryTotal title={"Total Sahaynidhi Claims"} dayTitle={'Last 30 days'} count={'800'} countLabel={'Successful Claims'} memberDetail={'5% Members Claim there insurance'} />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <PaperCommon
                            borderRadius={'16px'}
                            padding={'15px'}
                            contant={<SummaryTotal title={"Total Sahaynidhi Dis."} dayTitle={'Last 30 days'} count={'732'} countLabel={'Successful Claims'} memberDetail={'5% Members Claim there insurance'} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

const SummaryTotal = ({ title, dayTitle, count, countLabel, memberDetail }) => {
    const theme = useTheme()
    return (
        <>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} flexWrap={'wrap'} >
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={0.8}>
                    {/* <GroupsOutlinedIcon sx={{ color: "#3E4094", }} /> */}
                    <TextLabel title={title} fontSize={{ xs: "9px", sm: "12px" }} lineHeight={"29.11px"} fontWeight={'bold'} />
                </Box>
                <Box>
                    <TextLabel title={dayTitle} fontSize={{ xs: "8px", sm: "11px" }} color={theme?.palette?.primary?.main} />
                </Box>
            </Box>
            <Divider />
            <Typography variant="h4" paddingTop={4} fontWeight={600} sx={{ color: "#3E4094" }}>
                {count}
                <span style={{ fontSize: "0.8rem", fontWeight: 400, paddingLeft: 2, color: theme?.palette?.bgBlack?.main }}>{countLabel}</span>
            </Typography>
            <TextLabel title={memberDetail} fontSize={'12px'} color={theme?.palette?.bgLightBlack?.main} />
        </>
    )
}

export default Dashboard
